<template>
  <div>
    <v-app-bar flat color="red-darken-3">
      <v-app-bar-title class="hidden-sm-and-down">
        {{ $t("tests.label") }}
      </v-app-bar-title>
      <v-divider class="mx-5 hidden-sm-and-down" inset vertical />
      <v-text-field
        v-model="search"
        :label="$t('tests.search')"
        flat
        variant="solo"
        color="red-darken-1"
        append-inner-icon="mdi-magnify"
        single-line
        hide-details
      />
      <v-spacer class="hidden-sm-and-down" />

      <v-btn
        v-if="
          $store.getters.role == 'LekoAdmin' ||
          $store.getters.role == 'LekoEmployee' ||
          $store.getters.role == 'SuperAdmin'
        "
        color="grey-darken-4"
        variant="flat"
        @click="dialog = true"
      >
        {{ $t("tests.button") }}
        <v-icon end>mdi-plus</v-icon>
      </v-btn>
      <v-dialog v-model="dialog" persistent max-width="500px">
        <v-card>
          <v-card-title class="redColor">
            <span v-if="edit == true" class="headline">{{
              $t("tests.form.edit_test")
            }}</span>
            <span v-if="edit == false" class="headline">{{
              $t("tests.form.create_test")
            }}</span>
          </v-card-title>
          <v-card-text>
            <v-form ref="form" v-model="valid" lazy-validation>
              <v-container grid-list-md>
                <v-row wrap>
                  <v-col xs="12" md="12" lg="12">
                    <v-select
                      v-model="test.part_id"
                      :items="parts"
                      :label="$t('tests.form.select_part')"
                      color="red-darken-1"
                      item-title="title"
                      item-value="_id"
                      return-object
                    />
                    <!-- <v-menu transition="slide-y-transition" bottom>
                    <v-btn variant="outlined" @click="getParts" slot="activator" color="primary" dark>
                      {{$t('tests.form.select_part')}}
                      <v-icon right>arrow_drop_down</v-icon>
                    </v-btn>
                    <v-list>
                      <v-list-tile
                        v-for="(part, index) in parts"
                        :key="index"
                        @click="getPartId(part._id)"
                      >
                        <v-list-tile-title>{{ part.title }}</v-list-tile-title>
                      </v-list-tile>
                    </v-list>
                  </v-menu> -->
                  </v-col>
                  <v-col xs="12" md="12" lg="12">
                    <v-text-field
                      v-model="test.title"
                      :rules="rules.requiredLetters"
                      :label="$t('tests.form.title')"
                      color="red-darken-1"
                    />
                  </v-col>
                  <v-col xs="12" md="12" lg="12">
                    <v-text-field
                      v-model="test.description"
                      :rules="rules.requiredLetters"
                      :label="$t('tests.form.description')"
                      color="red-darken-1"
                    />
                  </v-col>
                  <v-col xs="12" md="12" lg="12">
                    <!-- <v-text-field v-model="test.photo" label="Photos"></v-text-field> -->

                    <label for="photo">{{
                      $t("tests.form.upload_photo")
                    }}</label>
                    <br />
                    <input
                      id="photo"
                      ref="photos"
                      name="photos"
                      type="file"
                      enctype="multipart/form-data"
                      multiple
                      @change="getPhotos()"
                    />
                  </v-col>
                  <v-col xs="12" md="12" lg="12">
                    <!-- <v-text-field v-model="test.video" label="Videos"></v-text-field> -->

                    <label for="video">{{
                      $t("tests.form.upload_video")
                    }}</label>
                    <br />
                    <input
                      id="video"
                      name="videos"
                      type="file"
                      enctype="multipart/form-data"
                      multiple
                      @change="getVideos($event)"
                    />
                  </v-col>
                  <v-col xs="12" md="12" lg="12">
                    <v-text-field
                      v-model="test.results"
                      :rules="rules.requiredLetters"
                      :label="$t('tests.form.results')"
                      color="red-darken-1"
                    />
                  </v-col>
                  <v-col xs="12" md="12" lg="12">
                    <v-select
                      v-model="test.warranty_id"
                      :items="warranties"
                      :label="$t('tests.form.select_warranty')"
                      color="red-darken-1"
                      item-title="title"
                      item-value="_id"
                      return-object
                    />
                  </v-col>
                </v-row>
              </v-container>
            </v-form>
          </v-card-text>
          <v-card-actions>
            <v-spacer />
            <v-btn color="red-darken-1" variant="outlined" @click="close">
              {{ $t("tests.form.close") }}
            </v-btn>
            <v-btn
              :disabled="!valid"
              color="green darken-1"
              variant="outlined"
              @click="save"
            >
              {{ $t("tests.form.save") }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-app-bar>

    <v-alert
      :model-value="alert.value"
      type="error"
      variant="tonal"
      border="bottom"
    >
      {{ alert.message }}
    </v-alert>

    <v-data-table
      :headers="headers"
      :items="tests.tests"
      :search="search"
      :loading="loading"
      :items-per-page="-1"
      hide-default-footer
      class="elevation-1 nowrap-headers"
    >
      <template #progress>
        <v-progress-linear color="red" indeterminate />
      </template>
      <template #item="{ item, index }">
        <tr
          :class="{ tableRowColorSelected: index == activeRow }"
          class="tableRowColor"
          @click="activeRow = index"
        >
          <td class="text-xs">
            {{ item.title }}
          </td>
          <td class="text-xs">
            {{ item.description }}
          </td>
          <td class="text-xs">
            {{ item.part_id }}
          </td>
          <!-- <td class="text-xs">{{ item.photo }}</td> -->
          <td>
            <img
              v-for="(photo, index) in item.photo"
              :key="index"
              :src="`${server}/images/?q=${item._id}-${item.photo[index]}`"
              height="35"
              width="35"
            />
          </td>
          <td class="text-xs">
            {{ item.video }}
          </td>
          <td class="text-xs">
            {{ item.results }}
          </td>
          <td class="text-xs">
            {{ item.warranty_id }}
          </td>
          <td class="ma-1 pa-4">
            <v-row class="d-flex flex-column align-center">
              <qr-code :size="50" :text="item._id" />
              <h4>
                {{ item._id.slice(item._id.length - 4, item._id.length) }}
              </h4>
            </v-row>
          </td>
          <td
            v-if="
              $store.getters.role == 'LekoAdmin' ||
              $store.getters.role == 'LekoEmployee' ||
              $store.getters.role == 'SuperAdmin'
            "
            class="justify-center"
          >
            <v-row align-center>
              <v-icon class="mr-2 pointer" @click="editTest(item._id)">
                mdi-pencil
              </v-icon>
              <v-icon class="pointer" @click="deleteTest(item._id)">
                mdi-delete
              </v-icon>
            </v-row>
          </td>
        </tr>
      </template>
    </v-data-table>

    <v-dialog v-model="dialogDelete" width="auto">
      <v-card>
        <v-card-title class="text-h6">
          <v-alert
            class="mb-0"
            :value="true"
            type="error"
            border="bottom"
            variant="tonal"
          >
            {{ $t("delete_alert") }}
          </v-alert>
        </v-card-title>

        <v-card-actions>
          <v-spacer />
          <v-btn variant="text" @click="dialogDelete = false">
            {{ $t("close") }}
          </v-btn>
          <v-btn color="red" variant="outlined" @click="confirmDelete()">
            {{ $t("delete") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import VueQrCode from "vue-qr-generator";

import getRequest from "../../api/getRequest";
import postRequest from "../../api/postRequest";
import putRequest from "../../api/putRequest";
import deleteRequest from "../../api/deleteRequest";

export default {
  components: {
    "qr-code": VueQrCode,
  },
  data: () => ({
    loading: true,
    search: "",
    valid: true,
    dialog: false,
    alert: {
      value: false,
      message: String,
    },
    headers: [
      {
        title: "",
        sortable: false,
        key: "title",
      },
      {
        title: "",
        sortable: false,
        key: "description",
      },
      {
        title: "",
        sortable: false,
        key: "part_id",
      },
      {
        title: "",
        sortable: false,
        key: "photo",
      },
      {
        title: "",
        sortable: false,
        key: "video",
      },
      {
        title: "",
        sortable: false,
        key: "results",
      },
      {
        title: "",
        sortable: false,
        key: "warranty_id",
      },
      {
        title: "Qr Code",
        sortable: false,
        key: "qr_code",
      },
      {
        title: "",
        sortable: false,
      },
    ],
    files: {},
    test: {},
    tests: {},
    parts: [],
    warranties: [],
    rules: {
      requiredLetters: [
        (v) => !!v || "Please fill this field",
        (v) => /[A-Za-z]/.test(v) || "Only letters are allowed",
      ],
    },
    edit: false,
    // eslint-disable-next-line no-undef
    token: localStorage.token,
    activeRow: null,
    dialogDelete: false,
    testToDelete: null,
  }),
  computed: {
    server() {
      return this.$serverUri;
    },
  },
  created() {
    this.getTests();
    this.getParts();
    this.getWarranties();
    this.getLocale();
    this.edit = false;
    if (
      this.$store.getters.role === "User" ||
      this.$store.getters.role === "EbayOperator"
    ) {
      this.headers.pop();
    }
    this.activeRow = null;
  },
  methods: {
    getLocale() {
      // eslint-disable-next-line global-require, import/no-dynamic-require
      const locale = require(
        `@/assets/locales/${this.$store.getters.language}.json`,
      );
      this.headers[0].title = locale.tests.table.title;
      this.headers[1].title = locale.tests.table.description;
      this.headers[2].title = locale.tests.table.part_id;
      this.headers[3].title = locale.tests.table.photo;
      this.headers[4].title = locale.tests.table.video;
      this.headers[5].title = locale.tests.table.results;
      this.headers[6].title = locale.tests.table.warranty_id;
      this.headers[7].title = locale.tests.table.qr_code;
      this.headers[8].title = locale.tests.table.actions;
    },
    uploadFiles(fileId) {
      const formData = new FormData();
      for (let i = 0; i < this.files.length; i += 1) {
        const file = this.files[i];
        formData.append("photos", file);
      }
      postRequest
        .object("/test/photos/", `q=${fileId}`, formData, {
          headers: {
            authorization: this.token,
            "Content-Type": "multipart/form-data",
          },
        })
        .then((response) => {
          if (response.status === 200) {
            this.getTests();
          }
        });
    },
    getPhotos() {
      const photos = [];
      for (let i = 0; i < this.$refs.photos.files.length; i += 1) {
        photos.push(this.$refs.photos.files[i].name);
      }
      this.files = this.$refs.photos.files;
      this.test.photo = photos;
    },
    getVideos(video) {
      const videos = [];
      for (let i = 0; i < video.target.files.length; i += 1) {
        videos.push(video.target.files[i].name);
      }
      this.test.video = videos;
    },
    getTests() {
      getRequest("/test/")
        .then((response) => {
          this.tests = response;
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    close() {
      this.$refs.form.reset();
      this.edit = false;
      this.dialog = false;
      this.test = {};
      this.getTests();
    },
    save() {
      if (this.$refs.form.validate()) {
        this.loading = true;
        if (this.edit === true) {
          putRequest("/test/", `id=${this.test._id}`, this.test)
            .then((response) => {
              this.uploadFiles(response.data.id);
            })
            .catch(() => {
              this.alert.value = true;
              this.alert.message = "Something went wrong";
              setTimeout(() => {
                this.alert.value = false;
              }, 2000);
            });
        } else {
          postRequest
            .object("/test/", this.test)
            .then((response) => {
              this.uploadFiles(response.data.id);
            })
            .catch(() => {
              this.alert.value = true;
              this.alert.message = "Something went wrong";
              setTimeout(() => {
                this.alert.value = false;
              }, 2000);
            });
        }
        this.dialog = false;
        this.edit = false;
        this.test = {};
      }
    },
    editTest(testId) {
      this.edit = true;
      getRequest("/test/", `id=${testId}`).then((response) => {
        this.test = response.test[0]; // eslint-disable-line prefer-destructuring
      });
      this.dialog = true;
    },
    deleteTest(testId) {
      this.testToDelete = testId;
      this.dialogDelete = true;
    },
    confirmDelete() {
      this.loading = true;
      deleteRequest("/test/", `id=${this.testToDelete}`).then((response) => {
        if (response.status === 200) {
          this.testToDelete = null;
          this.dialogDelete = false;
          this.loading = false;
          this.getTests();
        }
      });
    },
    getParts() {
      getRequest(
        "/part/",
        `user_id=${this.$store.getters.userId}&role=${this.$store.getters.role}`,
      )
        .then((response) => {
          this.parts = response.parts;
        })
        .catch(() => {});
    },
    getWarranties() {
      getRequest("/warranty")
        .then((response) => {
          this.warranties = response.warranties;
        })
        .catch(() => {});
    },
  },
};
</script>
